module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__wrap--bg cmp-modal",
    attrs: {
      "id": "introductionEx1"
    }
  }, [_c('div', {
    staticClass: "modal-wrap-container modal-wd1020"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("자기소개서 예시")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body-container ht-full"
  }, [_c('div', {
    staticClass: "box-type bg-primary block text-l mt-40"
  }, [_vm._v("\n        ※ 예시용 자기소개서는 백지에 첫 문장을 작성하시기 어려운 분들을 위한 참고용으로 가상의 조건을 설정해 작성된 내용이오니, "), _c('span', {
    staticClass: "color-hilight"
  }, [_vm._v("반드시 참고용으로만 확인해")]), _vm._v(" 주세요\n      ")]), _vm._v(" "), _c('h3', {
    staticClass: "section-title color-primary mt-40"
  }, [_vm._v("자기소개서 예시 (경영사무직, 재취업용)")]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("자기소개서 예시 (경영사무직, 재취업용) 표")]), _vm._v(" "), _c('colgroup', [_c('col')]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "cover-letter-section"
  }, [_c('h4', [_vm._v("1. 성장과정 및 성격의 장단점")]), _vm._v(" "), _c('p', [_vm._v("20여 년 이상을 직장 생활 속에서 보내며 성실과 책임감을 가장 중요한 가치로 여겨왔습니다. 조직생활에 있어서 가장 필요한 자질은 신뢰와 책임이라 믿으며, 주어진 역할에 묵묵히 최선을 다하는 태도로 주변 동료 및 상사들과의 원만한 관계를 유지해왔습니다. 한편, 지나치게 꼼꼼하고 완벽을 추구하려는 성향은 때로는 의사결정을 지연시키기도 했지만, 다양한 프로젝트를 수행하며 속도와 효율의 균형을 맞추는 노하우도 함께 체득했습니다.")])]), _vm._v(" "), _c('div', {
    staticClass: "cover-letter-section"
  }, [_c('h4', [_vm._v("2. 경영사무 분야에서의 주요 경력 및 역량")]), _vm._v(" "), _c('p', [_vm._v("저는 OO기업 경영지원팀에서 15년 이상 근무하며 총무, 인사, 문서관리, 회계체 운영, 대외행정 대응 등 다양한 사무행정 업무를 수행해왔습니다. 특히 임직원 복리후생 제도 개선, 사내 업무 프로세스 매뉴얼화, 신규 인사시스템 도입 등의 주요 과제를 맡아 성공적으로 마무리하였습니다. 또한 타 부서와의 소통, 외부 기관과의 문서 소통, 예산 집행 업무에서도 꼼꼼하고 책임 있는 태도로 좋은 평가를 받아왔습니다.")])]), _vm._v(" "), _c('div', {
    staticClass: "cover-letter-section"
  }, [_c('h4', [_vm._v("3. 지원 동기 및 입사 후 포부")]), _vm._v(" "), _c('p', [_vm._v("오랜 시간 현장에서의 실무 경험을 바탕으로, 여전히 조직에 기여할 수 있는 부분이 많다고 생각합니다. 특히 귀사는 최근 조직 효율성과 내부 프로세스 정비에 힘을 쏟고 있는 것으로 알고 있으며, 이러한 시점에서 제가 갖고 있는 실행력과 조정 능력, 그리고 실무 중심의 경영지원 역량이 도움이 될 수 있을 것이라 판단하여 지원하게 되었습니다. 입사 후에는 기존 경력에만 의존하지 않고, 변화하는 업무 환경과 디지털 툴에도 유연하게 적응하며, 신뢰할 수 있는 경영사무 지원 파트너로 자리매김하겠습니다.")])]), _vm._v(" "), _c('div', {
    staticClass: "cover-letter-section"
  }, [_c('h4', [_vm._v("4. 지원 동기 및 포부")]), _vm._v(" "), _c('p', [_vm._v("귀 요양기관은 지역 내에서 정성과 인격을 중시하는 돌봄 철학으로 잘 알려져 있으며, 저 역시 사람을 소중히 여기는 마음을 바탕으로 어르신들에게 진심 어린 돌봄을 실천하고 싶습니다. 현장에서 필요한 역할을 겸손하게 배우고, 팀원들과 소통하며 어르신들의 건강하고 따뜻한 일상을 지원하는 든든한 요양보호사가 되겠습니다.")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-md mo-button-full button-wid150",
    attrs: {
      "type": "button",
      "onclick": "closeModal(event)"
    }
  }, [_vm._v("\n        닫기\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-close only-icon close-modal",
    attrs: {
      "type": "button",
      "aria-label": "닫기",
      "onclick": "closeModal(event)",
      "title": "닫기"
    }
  }, [_c('i', {
    staticClass: "ico ico-x-bl"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d2b498d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/resume/IntroductionEx1.vue
// module id = 1341
// module chunks = 6